// extracted by mini-css-extract-plugin
export default {"button":"SearchButton_button__leOj2"};